function initWhenVisible(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.isVerticalView = this.getAttribute('is-vertical-view');
    this.offsetKey = this.isVerticalView ? 'offsetTop' : 'offsetLeft';
    this.clientMeasureKey = this.isVerticalView ? 'clientHeight' : 'clientWidth';
    this.scrollOrientationKey = this.isVerticalView ? 'scrollTop' : 'scrollLeft';
    this.orientationKey = this.isVerticalView ? 'top' : 'left';
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderId = this.slider.id;
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.navItems = document.querySelectorAll(`[slider-nav-id="${this.sliderId}"]`);

    if (!this.slider || !this.prevButton) return;

    initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.navItems?.forEach(navItem => navItem.addEventListener('click', e => this.onButtonClick(e, true)));
    window.addEventListener('resize', () => {
      this.isVerticalView = this.getAttribute('is-vertical-view');
      this.updateKeys();
      this.update();
    })
  }

  updateKeys() {
    this.offsetKey = this.isVerticalView ? 'offsetTop' : 'offsetLeft';
    this.clientMeasureKey = this.isVerticalView ? 'clientHeight' : 'clientWidth';
    this.scrollOrientationKey = this.isVerticalView ? 'scrollTop' : 'scrollLeft';
    this.orientationKey = this.isVerticalView ? 'top' : 'left';
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element[this.clientMeasureKey] > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1][this.offsetKey] - this.sliderItemsToShow[0][this.offsetKey];
    this.slidesPerPage = Math.floor(this.slider[this.clientMeasureKey] / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    console.log('---scroll---', this.slider[this.scrollOrientationKey]);
    const previousPage = this.currentPage;
    const previousNavItem = document.querySelector(`[slider-nav-id="${this.sliderId}"][data-index="${previousPage}"]`);
    this.currentPage = Math.round(this.slider[this.scrollOrientationKey] / this.sliderItemOffset) + 1;
    const currentNavItem = document.querySelector(`[slider-nav-id="${this.sliderId}"][data-index="${this.currentPage}"]`);

    if (previousNavItem) {
      previousNavItem.classList.remove('is-active');
    }

    if (currentNavItem) {
      currentNavItem.classList.add('is-active');
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons');
    } else {
      this.classList.remove('slider--no-buttons');
    }

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    // if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
    //   this.prevButton.setAttribute('disabled', 'disabled');
    // } else {
    //   this.prevButton.removeAttribute('disabled');
    // }

    if (this.slider[this.scrollOrientationKey] < 10) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!element) return false;
    const lastVisibleSlide = this.slider[this.clientMeasureKey] + this.slider[this.scrollOrientationKey] - offset;
    return (element[this.offsetKey] + element[this.clientMeasureKey]) <= lastVisibleSlide && element[this.offsetKey] >= this.slider[this.scrollOrientationKey];
  }

  onButtonClick(event, isNavItem) {
    event.preventDefault();
    if (isNavItem) {
      const index = Number(event.currentTarget.dataset.index);
      const targetSlide = this.querySelector(`#Slide-menu-categories-${index}`);
      const step = index - this.currentPage;
      return targetSlide.scrollIntoView({ behavior: 'smooth' });
      console.log('navItem', event, targetSlide[this.scrollOrientationKey]);
      this.slideScrollPosition = step ? this.slider[this.scrollOrientationKey] + (step * this.sliderItemOffset) : 0;
    } else {
      const step = event.currentTarget.dataset.step ? Number(event.currentTarget.dataset.step) : 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider[this.scrollOrientationKey] + (step * this.sliderItemOffset) : this.slider[this.scrollOrientationKey] - (step * this.sliderItemOffset);
    }
    // this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      [this.orientationKey]: this.slideScrollPosition,
      behavior: 'smooth',
    });
  }
}
customElements.define('slider-component', SliderComponent);

class PageSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    // const step = event.currentTarget.dataset.step || 1;
    const containerWidth = this.clientWidth - 180;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + containerWidth : this.slider.scrollLeft - containerWidth;
    console.log('---scroll-click--', this.slider.scrollLeft, this.innerWidth, this.slideScrollPosition);
    // this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: 'smooth'
    });
  }
}
customElements.define('page-slider-component', PageSliderComponent);

class SimpleCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectors = {
      sliderWrapper: '.swiper-wrapper',
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      pagination: '.swiper-pagination'
    };
    this.classes = {
      grid: 'f-grid',
      swiper: 'swiper',
      swiperWrapper: 'swiper-wrapper',
    };

    this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
    this.customEvent = this.dataset.customEvent;

    this.enableSlider = this.dataset.enableSlider === 'true';
    this.items = this.dataset.items !== 'auto' ? parseInt(this.dataset.items) : 'auto';
    this.tabletItems = this.dataset.items !== 'auto' ? parseInt(this.dataset.tabletItems) : 'auto';
    this.laptopItems = this.dataset.items !== 'auto' ? parseInt(this.dataset.laptopItems) : 'auto';
    this.paginationType = this.dataset.paginationType || 'bullets';

    this.sliderInstance = false;

    if (!this.enableSlider) return;

    const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
    mql.onchange = this.init.bind(this);
    this.init();
  }

  init() {
    // if (FoxTheme.config.mqlMobile) {
    //   this.destroySlider();
    // } else {
    // }
    this.initSlider();
  }

  initSlider() {
    if (typeof this.sliderInstance === 'object') return;
    const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap') || '0';
    const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
    const additionModules = [FoxTheme.Swiper.Mousewheel];
    this.sliderOptions = {
      slidesPerView: 'auto',
      spaceBetween: spaceBetween,
      navigation: {
        nextEl: this.querySelector(this.selectors.nextEl),
        prevEl: this.querySelector(this.selectors.prevEl),
      },
      pagination: {
        el: this.querySelector(this.selectors.pagination),
        type: this.paginationType,
      },
      breakpoints: {
        768: {
          slidesPerView: this.tabletItems,
        },
        1024: {
          slidesPerView: this.laptopItems,
        },
        1280: {
          slidesPerView: this.items,
        },
      },
      loop: false,
      threshold: 2,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    };

    if (this.dataset.autoplay) {
      additionModules.push(FoxTheme.Swiper.Autoplay)
      this.sliderOptions.autoplay = {
        delay: Number(this.dataset.autoplay) * 1000,
        disableOnInteraction: true
      }
    }

    if (this.dataset.effect === 'fade') {
      this.sliderOptions.effect = 'fade';
      additionModules.push(FoxTheme.Swiper.EffectFade)
    }

    if (this.dataset.loop) {
      this.sliderOptions.loop = true;
    }

    if (this.dataset.autoheight) {
      this.sliderOptions.autoHeight = true;
    }

    this.classList.add(this.classes.swiper);
    this.sliderWrapper.classList.remove(this.classes.grid);
    this.sliderWrapper.classList.add(this.classes.swiperWrapper);

    this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, additionModules);
    this.sliderInstance.init();
    if (this.customEvent) {
      this.sliderInstance.slider.on('realIndexChange', this.triggerCustomEvent.bind(this));
    }
  }

  triggerCustomEvent({ activeIndex }) {
    return document.dispatchEvent(new CustomEvent(this.customEvent, { detail: { activeIndex } }));
  }

  destroySlider() {
    this.classList.remove(this.classes.swiper);
    this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
    this.sliderWrapper.classList.add(this.classes.grid);
    if (typeof this.sliderInstance !== 'object') return;
    this.sliderInstance.slider.destroy();
    this.sliderInstance = false;
  }
}
customElements.define('simple-carousel', SimpleCarousel);

class QuantityAdjustor extends HTMLElement {
  constructor() {
    super();

    this.ELM_buttons = this.querySelectorAll('button');
    this.ELM_input = this.querySelector('input');
    this.min = this.ELM_input.getAttribute('min');

    this.ELM_buttons.forEach(ELM_button => ELM_button.addEventListener('click', () => this.update(ELM_button)));
  }

  update(btn) {
    const type = btn.name;
    return type === 'plus' ? this.plus() : this.minus();
  }

  plus() {
    this.ELM_input.value = Number(this.ELM_input.value) + 1;
  }

  minus() {
    const value = Number(this.ELM_input.value);
    if (value === 1) return;
    this.ELM_input.value = value - 1;
  }
}
customElements.define('quantity-adjustor', QuantityAdjustor);

class CopyText extends HTMLElement {
  constructor() {
    super();
    this.ELM_button = this.querySelector('button');
    this.ELM_text = this.querySelector('[data-text]');
    this.text = this.ELM_text.dataset.text;

    this.ELM_button.addEventListener('click', this.copyText.bind(this));
  }

  copyText() {
    const self = this;
    const text = self.text;
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Text copied to clipboard:', text);
        this.classList.add('copied');
        setTimeout(() => {
          this.classList.remove('copied');
        }, 2000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  }
}
customElements.define('copy-text', CopyText);

class WCAnchor extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute('href');
    this.ELM_targetSection = document.querySelector(this.id);
    this.ELM_container = document.querySelector(this.dataset.container);
    if (!this.ELM_targetSection) return;
    
    this.addEventListener('click', () => {
      if (this.ELM_container) {
        this.ELM_container.scrollTo({
          top: this.ELM_targetSection.offsetTop - 120,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: this.ELM_targetSection.getBoundingClientRect().top + window.scrollY - 160,
          behavior: 'smooth'
        })
      }
      this.closest('.wc-anchors')?.querySelectorAll('wc-anchor')?.forEach(elm => elm.classList.remove('is-active'));
      this.classList.add('is-active');
    })

    if (!this.ELM_container) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('is-active');
          } else {
            this.classList.remove('is-active');
          }
        });
      }, {
        threshold: 0.2 // 0.5 means at least 50% of the element is visible
      });
  
      observer.observe(this.ELM_targetSection);
    }
  }

  isElementInView(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
customElements.define('wc-anchor', WCAnchor);

class WCTab extends HTMLElement {
  constructor() {
    super();
    this.ELM_tabs = this.closest('.wc-tabs')?.querySelectorAll('wc-tab');
    this.id = this.dataset.id;

    this.addEventListener('click', this.onUpdate.bind(this));
    const params = new URLSearchParams(window.location.search);
    const paramId = params.get('tab');
    if (paramId === this.id) {
      this.onUpdate();
    }
  }
  
  onUpdate() {
    const ELM_tabContents = document.querySelectorAll('[data-wc-tab-id]');
    ELM_tabContents?.forEach(elm => {
      elm.classList.toggle('hidden', elm.getAttribute('data-wc-tab-id') !== this.id)
    })
    this.ELM_tabs.forEach(elm => elm.classList.remove('is-active'));
    this.classList.add('is-active');
  }
}
customElements.define('wc-tab', WCTab);

class ReorderButton extends HTMLElement {
  constructor() {
    super();
    this.itemsHtml = this.querySelector('template')?.innerHTML || '';
    this.ELM_reorderContent = document.querySelector('reorder-content');
    if (!this.ELM_reorderContent) return;
    this.addEventListener('click', () => this.ELM_reorderContent.loadContent(this.itemsHtml));
  }
}
customElements.define('reorder-button', ReorderButton);

class ReorderContent extends HTMLElement {
  constructor() {
    super();
    this.ELM_modal = this.closest('modal-component');
    this.ELM_cartDrawer = document.querySelector('#CartDrawer');
    this.ELM_itemsContainer = this.querySelector('[aria-items-container]');
    this.ELM_addButton = this.querySelector('button[name="reorder"]');
    this.ELM_addButton.addEventListener('click', this.addAllProducts.bind(this));
  }

  loadContent(itemsHtml) {
    this.ELM_itemsContainer.innerHTML = itemsHtml;
    this.updateButtonState();
  }

  updateButtonState() {
    const ELM_availableItems = this.querySelectorAll('.reorder-item:not(.is-unavailable)');
    this.ELM_addButton.disabled = !ELM_availableItems?.length;
  }

  async addAllProducts() {
    this.enableLoading();
    const ELM_availableItems = this.querySelectorAll('.reorder-item:not(.is-unavailable)');
    const items = [];
    for (const elm of ELM_availableItems) {
      items.push({
        id: elm.querySelector('input[name="variantId"]').value,
        quantity: elm.querySelector('input[name="quantity"]').value
      })
    }
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items,
        sections: sectionsToBundle
      })
    });

    const parsedState = await response.json();
    const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
    cartJson['sections'] = parsedState['sections'];
    console.log('cartJson', cartJson);
    this.updateCart(cartJson);
    this.disableLoading();
    this.closeModal();
    this.openCartDrawer();
  }

  updateCart(cartJson) {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  }

  enableLoading() {
    this.ELM_addButton.classList.add('btn--loading');
  }

  disableLoading() {
    this.ELM_addButton.classList.remove('btn--loading');
  }

  openCartDrawer() {
    this.ELM_cartDrawer?.show();
  }

  closeModal() {
    this.ELM_modal.hide();
  }
}
customElements.define('reorder-content', ReorderContent);

class CouponApplier extends HTMLElement {
  constructor() {
    super();
    this.discountCode = this.dataset.code;
    this.ELM_errorMessage = this.querySelector('.__error-message');
    this.isOneWay = this.dataset.oneWay;

    this.addEventListener('click', () => {
      if (this.getAttribute('disabled')) return;
      this.enableLoading();
      const isApplied = this.classList.value.includes('--applied');
      if (isApplied) {
        this.removeButton.click();
      } else {
        this.applyCode();
      }
    })
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, ({ cart }) => {
        this.disableLoading();
        this.updateState(cart);
        if (this.ELM_errorMessage) {
          this.closeErrorMessage();
        }
      }
    );

    document.addEventListener('discount::error', e => {
      this.disableLoading();
      if (e.detail.discountCode === this.discountCode && this.ELM_errorMessage) {
        this.openErrorMessage(e.detail.message);
        this.ELM_errorMessage.querySelector('[data-error-message]').innerHTML = e.detail.message;
        this.ELM_errorMessage.classList.remove('hidden');
      }
    })

    this.ELM_errorMessage.querySelector('button')?.addEventListener('click', e => {
      e.stopPropagation();
      this.closeErrorMessage();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  openErrorMessage(message) {
    this.ELM_errorMessage.querySelector('[data-error-message]').innerHTML = message;
    this.ELM_errorMessage.classList.remove('hidden');
  }

  closeErrorMessage() {
    this.ELM_errorMessage.querySelector('[data-error-message]').innerHTML = '';
    this.ELM_errorMessage.classList.add('hidden');
  }

  get discountForm() {
    return document.querySelector('form[is="cart-discount"]');
  }

  get discountField() {
    return this.discountForm.querySelector('input[name="discount"]');
  }

  get discountFormButton() {
    return this.discountForm.querySelector('button[type="submit"]');
  }

  get removeButton() {
    return this.querySelector('button[is="cart-discount-remove"]');
  }

  applyCode() {
    if (this.discountField) {
      this.discountField.value = this.discountCode;
      this.discountFormButton.click();
    }
  }

  updateState(cartData) {
    this.removeButton.setAttribute('aria-disabled', 'false');
    const productOffer = this.closest('.product-special-offer');
    const discountCodes = cartData.discount_codes || [];
    if (discountCodes.findIndex(item => item.code === this.discountCode) > -1) {
      this.classList.add('--applied');
      productOffer?.classList.add('--applied');
      if (this.isOneWay) {
        this.setAttribute('disabled', true);
      }
    } else {
      this.classList.remove('--applied');
      productOffer?.classList.remove('--applied');
      this.removeAttribute('disabled');
    }
  }

  enableLoading() {
    this.classList.add('btn--loading');
  }

  disableLoading() {
    this.classList.remove('btn--loading');
  }
}
customElements.define('coupon-applier', CouponApplier);

class WCSearchForm extends HTMLElement {
  constructor() {
    super();
    this.ELM_input = this.querySelector('input');
    this.ELM_button = this.querySelector('button');
    this.ELM_container = this.closest('[data-search-container]');
    this.ELM_searchItems = this.ELM_container?.querySelectorAll('[data-search-item-data]');

    this.ELM_input.addEventListener('keyup', this.search.bind(this));
  }

  search() {
    const searchTerm = this.ELM_input.value?.toLowerCase() || '';
    this.ELM_container.classList.toggle('is-searching', !!searchTerm);
    this.ELM_searchItems?.forEach(ELM_searchItem => {
      const itemSearchData = ELM_searchItem.dataset.searchItemData?.toLowerCase();
      console.log(itemSearchData);
      ELM_searchItem.classList.toggle('search-hidden', !itemSearchData.includes(searchTerm));
    })
  }
}
customElements.define('wc-search-form', WCSearchForm);

class AddToWishlist extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.productId = this.dataset.productId;
    this.variantId = this.dataset.variantId;
    this.productUrl = this.dataset.productUrl;
    this.productImgsrc = this.dataset.productImgsrc;
    this.product = {
      epi: this.variantId,
      empi: this.productId,
      du: this.productUrl
    }

    document.addEventListener('wcWishlist::fetched', this.init.bind(this));
    document.addEventListener('wcWishlist::itemRemoved', e => {
      const removedProductId = e.detail?.item?.empi;
      if (self.productId == removedProductId) {
        self.classList.remove('is-added');
      }
    })
    document.addEventListener('wcWishlist::itemAdded', e => {
      const addedProductId = e.detail?.item?.empi;
      if (self.productId == addedProductId) {
        self.classList.add('is-added');
      }
    })

    function onSwymLoadCallback(swat) {
      console.log('wishlist-loaded----');
      self.addEventListener('click', () => {
        const isAdded = self.classList.value.includes('is-added');
        isAdded ? self.deleteFromList(swat) : self.addToList(swat);
      })

      swat.evtLayer.addEventListener('sw:removedfromwishlist', (event) => {
        const removedProductId = event?.detail?.d?.empi;
        if (self.productId == removedProductId) {
          self.classList.remove('is-added');
        }
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  }

  init() {
    this.classList.toggle('is-added', window.wcWishlist?.listcontents?.findIndex(item => item.empi == this.productId) > -1);
  }

  addToList(swat) {
    this.enableLoading();
    const listId = window.wcWishlist?.lid;
    if (!listId) return;
    swat.addToList(listId, this.product, (item) => { 
      this.classList.add('is-added');
      const showSnackbar = !!window.wcWishlist?.listcontents?.length;
      document.dispatchEvent(new CustomEvent('wcWishlist::itemAdded', { detail: { item, productImgsrc: this.productImgsrc, showSnackbar } }));
      this.disableLoading();
    });
  }

  deleteFromList(swat) {
    this.enableLoading();
    const listId = window.wcWishlist.lid;
    swat.deleteFromList(listId, this.product, (item) => { 
      this.classList.remove('is-added');
      document.dispatchEvent(new CustomEvent('wcWishlist::itemRemoved', { detail: { item , productImgsrc: this.productImgsrc } }));
      this.disableLoading();
    });
  }

  enableLoading() {
    this.querySelector('.loading__spinner')?.classList.remove('hidden');
  }

  disableLoading() {
    this.querySelector('.loading__spinner')?.classList.add('hidden');
  }
}
customElements.define('add-to-wishlist', AddToWishlist);

class WCWishlist extends HTMLElement {
  constructor() {
    super();
    this.isInPopup = this.dataset.isInPopup;
  }

  connectedCallback() {
    document.addEventListener('wcWishlist::fetched', () => this.renderWishList.bind(this)());
    document.addEventListener('wcWishlist::itemAdded', () => this.reRenderWishlist.bind(this)(true));
    document.addEventListener('wcWishlist::itemRemoved', () => this.reRenderWishlist.bind(this)(false));
  }
 
  reRenderWishlist(openPopup) {
    const self = this;
    function onSwymLoadCallback(swat) {
      swat.fetchLists({
        callbackFn: async (lists) => {
          window.wcWishlist = lists[0];
          self.renderWishList(openPopup);
        }
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  }

  async renderWishList(openPopup) {
    const self = this;
    const wishListProducts = window.wcWishlist.listcontents;
    if (!wishListProducts?.length) {
      this.updateEmptyStatus('show');
      return this.innerHTML = '';
    }

    const handles = wishListProducts.map(product => product.du.split('products/')[1]).join(',');
    await this.storeParamsToCart(handles);
    fetch(`/pages/swym-wishlist?view=wishlist${this.isInPopup ? '&inpopup=true' : ''}`)
      .then(res => res.text())
      .then(textHTML => {
        self.innerHTML = textHTML;
        const count = self.querySelector('[data-wishlist-items-count]')?.innerHTML;
        self.updateEmptyStatus(count === '0' ? 'show' : 'hide');
        self.updateCounters(count);
        if (openPopup && wishListProducts.length < 2) {
          const ELM_wishlistPopup = document.querySelector('#WCWishlistPopup');
          if (ELM_wishlistPopup) {
            ELM_wishlistPopup.show();
          }
        }
      })
  }

  async storeParamsToCart(handles) {
    const attributes = { wl_products: handles }
    return fetch(`/cart/update.js`, {
      method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes
        })
    }).then(response => response.json())
      .then(resJson => console.log(resJson))
  }

  updateCounters(count) {
    const ELM_wishlistCounters = document.querySelectorAll('wc-wishlist-counter');
    let value = '';
    const countLabel = count > 1 ? 'Products' : 'Product';
    if (count) {
      value = count + ' ' + countLabel;
    }
    ELM_wishlistCounters?.forEach(elm => elm.innerHTML = value);
  }

  updateEmptyStatus(status) {
    const ELM_container = this.closest('.wc-wishlist-container');
    const ELM_wishlistEmpty = ELM_container.querySelector('.wc-wishlist-empty');
    if (!ELM_wishlistEmpty) return;

    if (status !== 'show') {
      ELM_wishlistEmpty.setAttribute('hidden', true);
    } else {
      ELM_wishlistEmpty.removeAttribute('hidden');
    }
  }
}
customElements.define('wc-wishlist', WCWishlist);

class WCWishlistSnackbar extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('wcWishlist::itemAdded', e => {
      if (!e.detail.showSnackbar) return;
      this.show(e.detail.productImgsrc, FoxTheme.wishlistStrings.addedToWishlist);
      this.classList.add('--add');
    })

    document.addEventListener('wcWishlist::itemRemoved', e => {
      this.show(e.detail.productImgsrc, FoxTheme.wishlistStrings.removedFromWishlist);
      this.classList.remove('--add');
    })
  }

  show(productImgsrc, message) {
    this.innerHTML = `
      <span class="__image"><img src="${productImgsrc}" width="40px" height="40px" /></span>
      <span class="__message">${message}</span>
      <a href="#wcWishlistPopup" aria-controls="WCWishlistPopup" aria-expanded="false">
        <span>${FoxTheme.wishlistStrings.view}</span>
      </a>
    `;
    this.querySelector('a')?.addEventListener('click', () => {
      const ELM_wishlistButton = document.querySelector('[aria-controls="WCWishlistPopup"]');
      ELM_wishlistButton && ELM_wishlistButton.dispatchEvent(new Event('click'));
    })
    setTimeout(this.hide.bind(this), 3000);
  }

  hide() {
    this.innerHTML = '';
  }
}
customElements.define('wc-wishlist-snackbar', WCWishlistSnackbar);

class WCCartSnackbar extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cartSnackbar::popin', e => {
      const { cart, target, line, name } = e?.detail || {};
      const remainingItems = Number(target.value || '0');
      if (cart?.errors) return;
      const itemImgSrc = target?.dataset.itemImage;
      let message = remainingItems > 0 ? FoxTheme.cartStrings.remainingItemsInCart : FoxTheme.cartStrings.removedFromCart;
      if (remainingItems > 0) {
        const itemIndex = line - 1;
        const item = cart.items[itemIndex];
        const quantity = item.quantity || 0;
        message = message.replace('[quantity]', quantity);
      }
      this.show(itemImgSrc, message);
    })
  }

  show(productImgsrc, message) {
    this.innerHTML = `
      <span class="__image"><img src="${productImgsrc}" width="40px" height="40px" /></span>
      <span class="__message">${message}</span>
      ${message !== FoxTheme.cartStrings.removedFromCart ? `<a href="#cart" aria-controls="CartDrawer" aria-expanded="false">
        <span>${FoxTheme.cartStrings.cart}</span>
      </a>` : ''}
    `;
    if (message !== FoxTheme.cartStrings.removedFromCart) {
      this.querySelector('a')?.addEventListener('click', () => {
        const ELM_cartButton = document.querySelector('[aria-controls="CartDrawer"]');
        ELM_cartButton && ELM_cartButton.dispatchEvent(new Event('click'));
      })
    }
    setTimeout(this.hide.bind(this), 3000);
  }

  hide() {
    this.innerHTML = '';
  }
}
customElements.define('wc-cart-snackbar', WCCartSnackbar);

class WCWishlistCounter extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('wc-wishlist-counter', WCWishlistCounter);

class WCWishlistRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const listId = window.wcWishlist.lid;
      const product = {
        epi: this.dataset.variantId,
        empi: this.dataset.productId,
        du: this.dataset.productUrl
      }
      const productImgsrc = this.dataset.productImgsrc;

      function onSwymLoadCallback(swat) {
        swat.deleteFromList(listId, product, (item) => { 
          document.dispatchEvent(new CustomEvent('wcWishlist::itemRemoved', { detail: { item, productImgsrc } }));
        });
      }
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(onSwymLoadCallback);
    })
  }
}
customElements.define('wc-wishlist-remove-button', WCWishlistRemoveButton);

class SimpleSlideshow extends HTMLElement {
  constructor() {
    super();
    this.DURATION = Number(this.dataset.duration || '0') || 3000;
  }

  connectedCallback() {
    this.currentIndex = 0;
    this.itemCount = this.querySelectorAll('[data-slide-index]')?.length;
    if (!this.itemCount) return;
    this.theInterval = null;
    this.init();
  }

  init() {
    this.theInterval = setInterval(() => this.goNext(), this.DURATION);
  }

  goNext() {
    this.currentIndex = this.currentIndex >= this.itemCount - 1 ? 0 : this.currentIndex + 1;
    this.changeItem();
  }

  changeItem() {
    this.querySelector('[data-slide-index].active')?.classList.remove('active');
    this.querySelector(`[data-slide-index="${this.currentIndex}"]`)?.classList.add('active');
  }
}
customElements.define('simple-slideshow', SimpleSlideshow);

if (!customElements.get('product-group')) {
  customElements.define('product-group', 
    class ProductGroup extends HTMLElement {
      constructor() {
        super();
        this.theInterval = null;
        this.DURATION = Number(this.dataset.duration);
        this.SELECTORS = {
          thumbnail: '.wc-product-group-thumbnail',
          card: '.wc-product-group-card'
        }
        this.CLASSES = {
          active: 'is-active'
        }       
        
        this.autoplay = this.dataset.autoplay;
        this.currentIndex = 1;
        this.ELM_thumbnails = this.querySelectorAll(this.SELECTORS.thumbnail);
        this.itemCount = this.ELM_thumbnails?.length;

        if (!this.itemCount) return;
        this.init();
      }

      init() {
        if (this.autoplay) {
          this.theInterval = setInterval(() => this.goNext(), this.DURATION);
        }
        this.handleClick();
        this.addEventListener('mouseover', () => {
          if (this.autoplay) {
            if (this.theInterval) clearInterval(this.theInterval);
          }
        });
        this.addEventListener('mouseout', () => {
          if (this.autoplay) {
            if (this.theInterval) clearInterval(this.theInterval);
            this.theInterval = setInterval(() => this.goNext(), this.DURATION);
          }
        })
      }

      goNext() {
        this.currentIndex = this.currentIndex >= this.itemCount ? 1 : this.currentIndex + 1;
        this.changeItem();
      }

      changeItem() {
        const ELM_currentThumbnail = this.querySelector(`${this.SELECTORS.thumbnail}.${this.CLASSES.active}`);
        const ELM_currentCard = this.querySelector(`${this.SELECTORS.card}.${this.CLASSES.active}`);
        const ELM_nextThumbnail = this.querySelector(`${this.SELECTORS.thumbnail}[data-id="${this.currentIndex}"]`);
        const ELM_nextCard = this.querySelector(`${this.SELECTORS.card}[data-id="${this.currentIndex}"]`);
        ELM_currentThumbnail?.classList.remove(this.CLASSES.active);
        ELM_currentCard?.classList.remove(this.CLASSES.active);
        ELM_nextThumbnail?.classList.add(this.CLASSES.active);
        ELM_nextCard?.classList.add(this.CLASSES.active);
      }

      handleClick() {
        this.ELM_thumbnails?.forEach(ELM_thumbnail => ELM_thumbnail.addEventListener('click', () => {
          this.currentIndex = Number(ELM_thumbnail.dataset.id);
          this.changeItem();
          if (this.autoplay) {
            if (this.theInterval) clearInterval(this.theInterval);
            this.theInterval = setInterval(() => this.goNext(), this.DURATION);
          }
        }))
      }
    }
  )
}

class WaveCalendar extends HTMLElement {
  constructor() {
    super();
    this.CLASSES = {
      CALENDAR: 'wave-calendar',
      CALENDAR_BODY: 'wave-calendar-body',
      HEADING: 'wave-calendar-heading',
      HEADER: 'wave-calendar-header',
      DAY: 'wave-calendar-day',
      EMPTY: 'wave-calendar-day is-empty',
      HIGHLIGHTED: 'is-highlighted',
      FIRST_HIGHLIGHTED: 'is-first-highlighted',
      LAST_HIGHLIGHTED: 'is-last-highlighted',
      TODAY: 'is-today'
    }
    this.highlightedDates = this.dataset.highlightedDates?.split(',') || [];
    this.year = Number(this.dataset.year);
    this.month = Number(this.dataset.month);
    this.renderCalendar(this.year, this.month);
  }

  renderCalendar(year, month) {
    this.innerHTML = '';
    this.classList.add(this.CLASSES.CALENDAR);

    // Heading
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const heading = document.createElement('div');
    heading.className = this.CLASSES.HEADING;
    heading.textContent = monthNames[this.month] + ' ' + this.year;
    this.appendChild(heading);

    const calendarBody = document.createElement('div');
    calendarBody.className = this.CLASSES.CALENDAR_BODY;
    this.appendChild(calendarBody);
    const calendar = this.querySelector(`.${this.CLASSES.CALENDAR_BODY}`);

    // Weekday headers
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    weekdays.forEach(day => {
      const div = document.createElement('div');
      div.className = this.CLASSES.HEADER;
      div.textContent = day;
      calendar.appendChild(div);
    });

    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Empty cells before day 1
    for (let i = 0; i < firstDay; i++) {
      const empty = document.createElement('div');
      empty.className = this.CLASSES.EMPTY;
      calendar.appendChild(empty);
    }

    // Actual days
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day + 1);
      const dateStr = date.toISOString().split('T')[0];
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0]
      console.log(todayStr);

      const div = document.createElement('div');
      div.className = this.CLASSES.DAY;
      div.textContent = day;

      if (dateStr === todayStr) {
        div.classList.add(this.CLASSES.TODAY);
      }

      if (this.highlightedDates.includes(dateStr)) {
        div.classList.add(this.CLASSES.HIGHLIGHTED);
      }

      if (this.highlightedDates[0] === dateStr) {
        div.classList.add(this.CLASSES.FIRST_HIGHLIGHTED);
      }

      if (this.highlightedDates.at(-1) === dateStr) {
        div.classList.add(this.CLASSES.LAST_HIGHLIGHTED);
      }

      calendar.appendChild(div);
    }
  }
}
customElements.define('wave-calendar', WaveCalendar);

class MegaMenuSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.sliderId = this.id;
    this.navItems = document.querySelectorAll(`[slider-nav-id="${ this.sliderId }"]`);
    this.activeIndex = 0;
    this.initSlider();

    this.navItems?.forEach(navItem => navItem.addEventListener('click', (e) => {
      e.preventDefault();
      const idx = Number(navItem.dataset.index) - 1;
      this.menuSwiper.slideTo(idx);
    }))
  }

  initSlider() {
    if (typeof this.menuSwiper === 'object') return;

    this.menuSwiper = new Swiper(this, {
      direction: "vertical",
      slidesPerView: "auto",
      freeMode: true,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      mousewheel: true,
    });

    this.menuSwiper.on('realIndexChange', ({ activeIndex }) => {
      this.activeIndex = activeIndex;
      this.updateActiveNav();
    });
  }

  updateActiveNav() {
    this.navItems?.forEach(navItem => {
      const idx = Number(navItem.dataset.index) - 1;
      navItem.classList.toggle('is-active', idx == this.activeIndex)
    })
  }
}
customElements.define('mega-menu-swiper', MegaMenuSwiper);

class TabArrows extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabsCount = Number(this.dataset.tabsCount || '0');
    this.tabIndex = 0;
    this.ELM_currentTab = this.querySelector('[data-name="current-tab"]');
    this.ELM_buttonNext = this.querySelector('button[name="next-tab"]');
    this.ELM_buttonPrev = this.querySelector('button[name="previous-tab"]');

    this.ELM_buttonNext.addEventListener('click', this.toNextTab.bind(this));
    this.ELM_buttonPrev.addEventListener('click', this.toPrevTab.bind(this));
  }

  toNextTab() {
    this.tabIndex = this.tabIndex === this.tabsCount - 1 ? 0 : this.tabIndex + 1;
    this.updateTab();
  }

  toPrevTab() {
    this.tabIndex = this.tabIndex === 0 ? this.tabsCount - 1 : this.tabIndex - 1;
    this.updateTab();
  }

  updateTab() {
    this.querySelector(`.tabs__btn[data-index="${this.tabIndex}"]`)?.dispatchEvent(new Event('click'));
    this.updateCurentTab();
  }

  updateCurentTab() {
    this.ELM_currentTab.innerHTML = this.tabIndex + 1;
  }
}
customElements.define('tab-arrows', TabArrows);